export const CHANNELS = {
  TIKTOK: 'tiktok',
  MIRAKL: 'mirakl',
};
